/* * 主页 */
<template>
  <div ref="mainWrapper" class="home-page-view">
    <div ref="viewScrollContent" class="home_wrap scroll-view-scroll tran">
      <!-- 首页轮播图 -->
      <BannerForJddTab :isLoop="isLoop" :list="list" class="tran" :isOpenActivity="isOpenActivity" :ActivityBannerObj="ActivityBannerObj" :bannerBgColor="bannerBgColor"></BannerForJddTab>

      <FreePeriodRemind :data="freeperiodremindlist" :swiperOption="swiperOption" />
      <HomePageDailySelect ref="homePageDailySelect" @onLoadedDailySelect="onLoadedDailySelect"></HomePageDailySelect>

      <!-- 首页活动列表 -->
      <HomePageActivityList ref="homePageActivityList" @onBetterScrollRefresh="onPageActivityBetterScrollRefresh" @onEditTip="onEditTip" />
      <!-- 首页猜你喜欢列表 -->
      <HomeGuessWhatYouLike
        ref="homeGuessWhatYouLike"
        :categorys="guessLikeCategorys"
        :navigaterBarScrollCurrentIndex="guessLikeCurrentIndex"
        @onBetterScrollRefresh="onHomeGuessWhatYouLikeRefresh"
        @onItemClick="loadGuessLikeByCategory"
        @onNavBarScroll="onNavBarScroll"
        @onNavBarScrollEnd="onNavBarScrollEnd"
      />
    </div>
    <!-- 
        <Search
            :isScroll="isScroll"
            class="ui-fixed"
        /> -->
    <BottomSuspension />
    <AdvertisingMsterDialog />
  </div>
</template>
<script>
import ScrollView from '@/components/ScrollView.vue';
// import VerticalSlide from '@/components/VerticalSlide.vue';
import BannerForJddTab from '@/buscomponents/BannerForJddTab.vue';
import SmallFloatingLayer from '@/buscomponents/SmallFloatingLayer.vue';
import HomeGuessWhatYouLike from '@/buscomponents/HomeGuessWhatYouLike.vue';
import HomePageActivityList from '@/buscomponents/HomePageActivityList.vue';
import HomePageDailySelect from '@/buscomponents/HomePageDailySelect.vue';
import NavigaterBarScroll from '@/buscomponents/NavigaterBarScroll.vue';

import Search from '@/buscomponents/Search.vue';
import request from '@/util/request';
import { shareInit, HideShare } from '@/util/share';
import { setJDJRNativeHeaderColor } from '@/util/jdjrNative';
import { genLinkBySSR, isJdNavFun, hasNavFun } from '@/util/common';
import Slider from '@/components/Slider.vue';
import { messages } from '@/config';

import Tip from '@/buscomponents/Tip.vue';
import FreePeriodRemind from '@/buscomponents/FreePeriodRemind.vue';
import BottomSuspension from '@/buscomponents/BottomSuspension.vue';
import AdvertisingMsterDialog from '@/buscomponents/AdvertisingMsterDialog.vue';
import { delay } from '@/util/common';

export default {
  name: 'IndexPage',
  components: {
    ScrollView,
    SmallFloatingLayer,
    NavigaterBarScroll,
    HomeGuessWhatYouLike,
    HomePageActivityList,
    HomePageDailySelect,
    Slider,
    BannerForJddTab,
    Tip,
    Search,
    FreePeriodRemind,
    BottomSuspension,
    AdvertisingMsterDialog
  },
  data() {
    return {
      // list: swiperImgs,
      list: [],
      isOpenActivity: false,
      ActivityBannerObj: {},
      bannerBgColor: '#fff',
      isScroll: false,
      isLoop: true,
      tempGuessLikeCategorys: [],
      guessLikeCategorys: [],
      dailySelect: [],
      // 第一个banner
      bannerInfo: {
        isShowBanner: false
      },
      isBarFixed: false,
      guessLikeCurrentIndex: 0,
      hasFindCenter: false,
      hasJdNav: false,
      hasNav: false,
      tipContent: '',
      // 节流函数
      //优享-免息提醒
      freeperiodremindlist: [],
      swiperOption: {
        direction: 'vertical',
        loop: true,
        speed: 600,
        allowTouchMove: false,
        on: {
          click: function() {
            const realIndex = this.realIndex;
            this.handleClickSlide(realIndex);
          }
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
        // autoplay: false
      }
    };
  },
  created() {
    this.getFreeInterestCallList();
    try {
      HideShare({ title: '优享免息', moreItem: true, hideTools: false, textColor: 1 });
      const defaultOption = {
        shareURL: genLinkBySSR('activity'),
        shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
        shareTitle: messages.shareTitle,
        shareDesc: messages.shareDesc,
        shareChannels: ['0', '1', '3']
      };
      shareInit(defaultOption);
    } catch (error) {
      console.log(error);
    }

    this.timeLimeUpDown();
  },
  computed: {
    scrollHeight: () => {
      return document.body.scrollHeight;
    }
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        if (window.scrollTo) {
          window.scrollTo(0, 0);
        }
      });
    }, 200);
    try {
      window.addEventListener('scroll', this.handleScroll, false);
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    jumpPage() {
      window.location.href = 'https://m.jr.jd.com/btyingxiao/advertMoney/html/home.html';
    },
    handleScroll() {
      let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 设备/屏幕高度
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 到头部的距离
      let viewBox1 = this.$refs && this.$refs.viewScrollContent; // 滚动区域
      let scrollHeight = (viewBox1 && viewBox1.scrollHeight) || 0; // 滚动条的总高度
      //滚动条到底部的条件
      // if (scrollTop + clientHeight >= scrollHeight) {
      if (scrollTop >= 80) {
        // div 到头部的距离 + 屏幕高度 = 可滚动的总高度
        // this.isScroll = true;
        this.isScroll = false;
      }

      let t1 = 0;
      let t2 = 0;
      let timer = null; // 定时器
      let me = this;
      // scroll监听
      document.onscroll = function() {
        clearTimeout(timer);
        timer = setTimeout(isScrollEnd, 1000);
        t1 = document.documentElement.scrollTop || document.body.scrollTop;
      };

      function isScrollEnd() {
        t2 = document.documentElement.scrollTop || document.body.scrollTop;
        if (t2 == t1) {
          if (scrollTop >= 80) {
            me.isScroll = true;
          }
        }
      }
    },
    onMainScrolling() {},
    onMainScrollEnd() {},
    tryProcess() {},
    onPageActivityBetterScrollRefresh(opts) {
      this.onBetterScrollRefresh(opts);

      const stt2 = setTimeout(() => {
        clearTimeout(stt2);
        if (this.$refs && this.$refs.homeGuessWhatYouLike) {
          this.guessLikeCategorys = this.tempGuessLikeCategorys;

          this.$nextTick(() => {
            this.$refs.homeGuessWhatYouLike.firstLoadGuessLikeByCategory();
          });
        }
      }, 150);
    },
    onBetterScrollRefresh(opts = {}) {},
    onHomeGuessWhatYouLikeRefresh() {},
    loadGuessLikeByCategory({ category, index }) {
      this.guessLikeCurrentIndex = index;
      this.$refs.homeGuessWhatYouLike.loadGuessLikeByCategory(category, this.isBarFixed ? true : false);
    },
    onNavBarScroll(e) {},
    onNavBarScrollEnd(e) {
      console.log('onNavBarScroll11', e);
    },
    onFixBarScroll(e) {},
    onFixBarScrollEnd(e) {},

    //定时上下线
    timeLimeUpDown() {
      // this.$loading.show();
      let id = '100001029';
      if (process.env.VUE_APP_ENV === 'minner' || process.env.VUE_APP_ENV === 'dev') {
        id = '100001029';
      }

      request.contentConfigure({
        data: {
          id,
          auth: ['categorys', 'swiperImgs']
        },
        success: data => {
          if (this.$refs && this.$refs.homePageDailySelect) {
            this.$refs.homePageDailySelect.requestDailySelect();
          }

          if (data && data.json) {
            if (data.json.swiperImgs && data.json.swiperImgs.length) {
              this.list = data.json.swiperImgs;
            }

            if (data.json.categorys && data.json.categorys.length) {
              this.tempGuessLikeCategorys = data.json.categorys;
            }
            if (data.json.banner.bigBanner) {
              this.isOpenActivity = true;
              this.ActivityBannerObj = data.json.banner.bigBannerObject;
            } else {
              this.isOpenActivity = false;
              this.bannerBgColor = data.json.banner.bigBannerObject.backgroundColor;
            }
          }

          this.onBetterScrollRefresh();

          this.$nextTick(() => {
            delay(() => {
              $('.home-page-view').css({ 'padding-bottom': '1px' });
              window.scrollTo(0, 1);
            }, 200);
            delay(() => {
              $('.home-page-view').css({ 'padding-bottom': '' });
              window.scrollTo(0, 0);
            }, 500);
          });
        },
        afterError: () => {
          if (this.$refs && this.$refs.homePageDailySelect) {
            this.$refs.homePageDailySelect.requestDailySelect();
          }
        }
      });
    },

    onLoadedDailySelect() {
      delay(() => {
        if (this.$refs && this.$refs.homePageActivityList) {
          this.$refs.homePageActivityList.loadActivityList();
        }
      }, 150);

      this.onBetterScrollRefresh();
    },
    onEditTip(edit) {
      this.tipContent = edit || '';
    },
    getFreeInterestCallList() {
      // this.$loading.show();
      request.getFreeInterestCallList({
        // 参数
        data: {},
        // 成功
        success: data => {
          // this.$loading.hide();
          if (data && data.list) {
            this.freeperiodremindlist = data.list;
            if (data.list.length == 1) {
              this.swiperOption = {
                direction: 'vertical',
                loop: true,
                speed: 600,
                allowTouchMove: false,
                on: {
                  touchStart: function() {},
                  click: function() {}
                },
                autoplay: false
              };
            }
          }
        },
        // 接口失败
        afterError: () => {
          // this.$loading.hide();
        }
      });
    }
  },
  watch: {
    list: {
      /* eslint no-unused-vars:"off" */
      handler(curVal, oldVal) {
        oldVal = curVal;
      },
      deep: true
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
@import '@/scss/home.scss';

.home-page-view {
  .scroll-view-scroll {
    backface-visibility: hidden;
  }
}
.ui-fixed {
  position: fixed;
  left: 0;
  top: 0;
}
.coupons {
  background: url('https://img20.360buyimg.com/cms/jfs/t26665/304/201049247/9035/d806feaf/5b88f643N726179ae.jpg') repeat-y top center;
  background-size: 100% auto;
}
.coupons ul {
  overflow: hidden;
  width: 89.333%;
  margin: auto;
}
.coupons li {
  position: relative;
  float: left;
  width: calc(50% - 6px);
  margin: 5px;
  overflow: hidden;
}
.coupons li img {
  display: block;
  width: 100%;
}
.coupons .back-shade {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
.coupons .back-seal {
  position: absolute;
  right: 10px;
  top: 50%;
  width: 56px;
  height: 56px;
  margin-top: -31px;
  border: 3px solid #fff;
  border-radius: 50%;
  transform: rotate(-28deg);
  -webkit-transform: rotate(-28deg);
  opacity: 1;
  transition: all 0.4s ease-in;
  -webkit-transition: all 0.4s ease-in;
}
.coupons .back-seal .up-part {
  position: absolute;
  top: 5px;
  width: 100%;
  height: 12px;
  text-align: center;
  overflow: hidden;
}
.coupons .back-seal .up-part::before {
  content: '';
  display: inline-block;
  width: 44px;
  height: 44px;
  border: 2px solid #fff;
  border-radius: 50%;
}
.coupons .back-seal .down-part {
  position: absolute;
  bottom: 5px;
  width: 100%;
  height: 12px;
  text-align: center;
  overflow: hidden;
}
.coupons .back-seal .down-part::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 44px;
  height: 44px;
  margin-left: -24px;
  border: 2px solid #fff;
  border-radius: 50%;
}
.coupons .back-seal .content-part {
  position: relative;
  line-height: 56px;
  font-size: 14px;
  text-align: center;
  color: #fff;
}
.coupons .back-seal.get-it-out {
  transform: rotate(0) scale(5);
  -webkit-transform: rotate(0) scale(6);
  opacity: 0;
}
</style>
